import React, { useEffect, useRef } from 'react';

// Thin accent bar showing how far down the page you are.
function ScrollProgress() {
    const barRef = useRef(null);

    useEffect(() => {
        // Browsers with scroll-driven animations do this in CSS (see app.css).
        if (typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: scroll()')) return undefined;

        let ticking = false;
        const update = () => {
            const doc = document.documentElement;
            const max = doc.scrollHeight - doc.clientHeight;
            const progress = max > 0 ? Math.min(doc.scrollTop / max, 1) : 0;
            if (barRef.current) barRef.current.style.transform = `scaleX(${progress})`;
            ticking = false;
        };
        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(update);
            }
        };
        update();
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        return () => {
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', onScroll);
        };
    }, []);

    return (
        <div className='scrollProgress' aria-hidden='true'>
            <div ref={barRef} className='scrollProgress__bar' />
        </div>
    );
}

export default ScrollProgress;
